import { getRecommendationById } from '@/service/recommendation'

const initialState = {
  data: {
    post: {
      title: undefined,
      image: undefined,
      id: undefined,
      metrics: [
        {
          id: undefined,
          image: undefined,
          name: undefined,
        },
      ],
      body: {
        what: {
          title: undefined,
          content: undefined,
        },
        how: {
          title: undefined,
          content: [],
        },
        benefit: {
          title: undefined,
          content: undefined,
        },
      },
    },
  },
}

const state = initialState

const getters = {
  post: state => state.data.post,
}

const actions = {
  getRecommendationById({ commit }, recomendationId) {
    getRecommendationById(recomendationId).then(data => commit('setPost', data))
  },

  initializePost({ commit }, prop) {
    commit('initializePost', prop)
  },
}

const mutations = {
  setPost(state, data) {
    state.data.post = data
  },
  initializePost(state, data) {
    Object.assign(state.data.post, data)
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
